import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Mail, Phone } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.footer');
      if (footer && window.scrollY > 100) {
        footer.classList.add('footer-visible');
      } else if (footer) {
        footer.classList.remove('footer-visible');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const services = [
    'Website Design',
    'SEO Optimization',
    'Social Media Management',
    'Content Creation',
    'Video Production',
    'Facebook Marketing',
  ];

  const navigationItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'Our Policies', path: '/policies' },
    { name: 'Testimonials', path: '/testimonials' }
  ];

  const contactInfo = {
    emails: [
      'info@quantumframestudio.com'
    ],
    phones: [
      { number: '+91 9243015433', whatsapp: true }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-nav-services">
            <div className="footer-nav">
              <h3>Navigation</h3>
              <ul>
                {navigationItems.map((item) => (
                  <li key={item.name}>
                    <Link to={item.path}>
                      <ChevronRight className="icon" />
                      <span>{item.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-services">
              <h3>Our Services</h3>
              <div className="services-grid">
                {services.map((service) => (
                  <Link key={service} to="/services" className="service-item">
                    <ChevronRight className="icon" />
                    <span>{service}</span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="footer-contact">
              <h3>Contact Us</h3>
              <div className="contact-info">
                <div className="contact-section">
                  <h4 className="contact-subtitle">Email Us</h4>
                  {contactInfo.emails.map((email) => (
                    <a
                      key={email}
                      href={`mailto:${email}`}
                      className="contact-item"
                    >
                      <Mail className="icon" />
                      <span>{email}</span>
                    </a>
                  ))}
                </div>
                <div className="contact-section">
                  <h4 className="contact-subtitle">Call Us</h4>
                  {contactInfo.phones.map((phone) => (
                    <div key={phone.number} className="phone-links">
                      <a
                        href={`tel:${phone.number.replace(/\D/g, '')}`}
                        className="contact-item"
                      >
                        <Phone className="icon" />
                        <span>{phone.number}</span>
                      </a>
                      {phone.whatsapp && (
                        <a
                          href={`https://wa.me/${phone.number.replace(/\D/g, '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="whatsapp-link"
                        >
                          (WhatsApp)
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-newsletter">
            <h3>Subscribe to Our Newsletter</h3>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="input-group">
                <input type="email" placeholder="Your email address" required />
                <button type="submit">Subscribe</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-partition"></div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} QuantumFrame Studio. All rights reserved.</p>
        <div className="footer-social">
          {['Facebook', 'Twitter', 'Instagram', 'LinkedIn'].map((platform) => (
            <a
              key={platform}
              href={`https://${platform.toLowerCase()}.com/quantumframestudio`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {platform}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;